// removed by extract-text-webpack-plugin
module.exports = {"marketType":"_2QFMqhER_QhbZFKD5uZjgd","innerText":"_1zIfk6MY2omBHS-kVR6XdX","marketText":"_2qEKgyctTeHzDsX7R942un","tickMark":"_3lJf7vMD1LpufRQyZHbbTJ","oddsButton":"bRwhgJUm4BSup3GS_HIvm","checked":"_1mSrIdubey5BawCy4SkRp3","selected":"_2AembbJjL5HHOopubyuT9_","buttonCustomStyle":"FttgAv_TKeseK9xvv4k9-","customButtonContainer":"_1rAk6nrN6KY29h3lzyls5V","line":"_1-ovVOS81BATUU7_e_fJAh"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/sports-book/modules/americanFootball/css/oddsCard.css
// module id = 889
// module chunks = 0